import { useDispatch, useSelector } from "react-redux";
import lang from "../utils/lang";
import { useRef, useState } from "react";
import { openai } from "../utils/openAI";
import { options } from "../utils/tmdbToken";

import { addGptmovie, changeLoading } from "../utils/gptSlice";
import Shimmer from "./Shimmer";

const GPTsearchbar = () => {
  const languageChange = useSelector((store) => store.language.languageDefault);

  const searchValue = useRef(null);
  const dispatch = useDispatch();
  const [loading,setLoading] = useState(false)
  const HelperGPTmovie = async (movie) => {
    try {
      setLoading(true)
      dispatch(changeLoading());
      const fetchgptSugggestion = await fetch(
        `https://api.themoviedb.org/3/search/movie?query=${movie}&include_adult=false&language=en-US&page=1`,
        options
      );
      const data = await fetchgptSugggestion.json();
      return data.results;
      
    } catch (error) {
    } finally {
      setLoading(false)
    }
  };

  const handleSearch = async () => {
    const inputValue=searchValue.current.value
    const query =
    "Act as a Movie Recommendation system and suggest some movies for the query : " +
    inputValue +
    ". only give me names of 5 movies, comma separated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya";

    const completion = await openai.chat.completions.create({
      model: "gpt-3.5-turbo",
      messages: [{ role: "user", content: query }],
    });
    const gptmovie = completion?.choices[0]?.message?.content?.split(",");
    const data = gptmovie.map((movie) => HelperGPTmovie(movie));
    const resolveddata = await Promise.all(data);
    dispatch(addGptmovie({ movieNames: gptmovie, movieResults: resolveddata }));
  };

  return (
    <>
    
      <div className="flex  justify-center text-xl bg-gray-800">
      
        <form
          className="bg-black md:bg-transparent rounded-2xl relative mt-28 md:w-1/2 grid grid-flow-col p-4 font-bold text-white "
          onSubmit={(e) => e.preventDefault()}
        >
          
          <input
            ref={searchValue}
            className=" col-span-10 px-2 bg-blue-300 bg-opacity-20 bg-gradient-to-l from-black placeholder:text-white"
            type="search"
            placeholder={lang[languageChange].gptsearch}
          ></input>
          <button
            className="col-span-2 border mx-2 p-4 rounded-md bg-red-600 text-white"
            onClick={handleSearch}
          >
            {lang[languageChange].search}
          </button>
          
        </form>
        
      </div>
      {loading && (
        <div className=" flex justify-center mt-5 ">
          <Shimmer />
        </div>
      )}
    </>
  );
};
export default GPTsearchbar;
